import { Controller } from 'stimulus'
import { createPopper } from '@popperjs/core'

export default class extends Controller {
  connect() {
    this.actionFormController().addSuggestion('linked-items', this.element.dataset.name, this.element.dataset.rank, this.element.dataset.score, this.element.dataset.value)
  }

  addSuggestion(event) {
    this.removePopover(event)

    this.actionFormController().suggestionSelected('linked-items', this.element.dataset.name, this.element.dataset.value)

    this.linkedItemsTypeaheadController().selectOption(event)
    this.removeSuggestion(event.target)
  }

  showPopover(event) {
    const tooltip = this.tooltipElement(event)
    const offset = 20 // This value should match the popover arrow height

    createPopper(this.element, this.tooltipElement(event), {
      placement: 'top',
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, offset]
          }
        }
      ]
    })

    tooltip.setAttribute('data-show', '')
  }

  removePopover(event) {
    const tooltip = this.tooltipElement(event)

    tooltip.removeAttribute('data-show')
  }

  removeSuggestion(target) {
    const container = target.parentElement.parentElement

    if (container.childElementCount === 1) {
      container.parentElement.remove()
    } else {
      target.parentElement.remove()
    }
  }

  tooltipElement(event) {
    const i = Number(event.target.closest('li').dataset.rank) - 1

    return $('.tooltip').get()[i]
  }

  actionFormController() {
    return this.application.getControllerForElementAndIdentifier(document.getElementById('action-form'), 'action-form')
  }

  linkedItemsTypeaheadController() {
    return this.application.getControllerForElementAndIdentifier(document.getElementById('linked-items'), 'atomic--organism--typeahead-multiselect--component')
  }
}
